module.exports = __webpack_public_path__ + "0ac21b923d375082482991bb12adde62.svg";